export const DETECT_ENGANGE = 'DETECT_ENGANGE'
export const DETECT_ENGANGE_SUCCESS = 'DETECT_ENGANGE_SUCCESS'
export const DETECT_ENGANGE_FAILURE = 'DETECT_ENGANGE_FAILURE'
export const DETECT_ENGANGE_CLEAR = 'DETECT_ENGANGE_CLEAR'
